import React, { useState, useRef, useEffect } from 'react';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/selection/active-line';
import ReactDiffViewer from 'react-diff-viewer';
const _ = require('lodash');

import { AutoComplete, Tabs } from 'antd';
const { TabPane } = Tabs;

import './DifferentSetting.scss';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';

let tolConfig = {};
let curType = "client";
let curKey = "";
let database_config_content = "";
let differentSettingContent = "";
let DiffSettingUserGroups = [];
let ConversionInfos = null;
const Plans = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
let ContentInModal = '';
let CurrentPlan = 'planA';
let allPlatformList = [];
let initPlans = [{ title: 'planA-自然', key: 'planA' }];

const DifferentSetting = () => {
    const codeEditorRef = useRef();
    const [configListData, setConfigListData] = useState([]);
    const [platformAutoComplete, setPlatformAutoComplete] = useState([]);

    const [tabPlans, setTabPlans] = useState({
        activeKey: 'planA',
        panes: initPlans,
    });

    const [baseConfigValue, setBaseConfigValue] = useState('');
    const [specialConfigValue, setSpecialConfigValue] = useState('');
    const [splitView, setSplitView] = useState(true);

    const [splitGroupModalView, setSplitGroupModalView] = useState(true);


    const Country = `AD\t安道尔共和国\tAndorra,AE\t阿拉伯联合酋长国\tUnited Arab Emirates,AF\t阿富汗\tAfghanistan,AG\t安提瓜和巴布达\tAntigua and Barbuda\t,AI\t安圭拉岛\tAnguilla\t,AL\t阿尔巴尼亚\tAlbania\t,AM\t亚美尼亚\tArmenia\t,AC \t阿森松\tAscension\t,AO\t安哥拉\tAngola\t,AR\t阿根廷\tArgentina,AT\t奥地利\tAustria,AU\t澳大利亚\tAustralia,AZ\t阿塞拜疆\tAzerbaijan\t,BB\t巴巴多斯\tBarbados,BD\t孟加拉国\tBangladesh\t,BE\t比利时\tBelgium,BF\t布基纳法索\tBurkina-faso\t,BG\t保加利亚\tBulgaria,BH\t巴林\tBahrain,BI\t布隆迪\tBurundi,BJ\t贝宁\tBenin,PS\t巴勒斯坦\tPalestine,BM\t百慕大群岛\tBermuda Is.\t,BN\t文莱\tBrunei\t,BO\t玻利维亚\tBolivia\t,BR\t巴西\tBrazil,BS\t巴哈马\tBahamas\t,BW\t博茨瓦纳\tBotswana\t,BY\t白俄罗斯\tBelarus\t,BZ\t伯利兹\tBelize\t,CA\t加拿大\tCanada\t,KY\t开曼群岛\tCayman Is.\t,CF\t中非共和国\tCentral African Republic\t,CG\t刚果\tCongo\t,CH\t瑞士\tSwitzerland,CK\t库克群岛\tCook Is.\t,CL\t智利\tChile,CM\t喀麦隆\tCameroon\t,CN\t中国\tChina,CO\t哥伦比亚\tColombia,CR\t哥斯达黎加\tCosta Rica\t,CS\t捷克\tCzech\t,CU\t古巴\tCuba,CY\t塞浦路斯\tCyprus,CZ\t捷克\tCzech Republic,DE\t德国\tGermany,DJ\t吉布提\tDjibouti\t,DK\t丹麦\tDenmark,DO\t多米尼加共和国\tDominica Rep.,DZ\t阿尔及利亚\tAlgeria,EC\t厄瓜多尔\tEcuador,EE\t爱沙尼亚\tEstonia,EG\t埃及\tEgypt,ES\t西班牙\tSpain,ET\t埃塞俄比亚\tEthiopia\t,FI\t芬兰\tFinland\t,FJ\t斐济\tFiji,FR\t法国\tFrance,GA\t加蓬\tGabon\t,GB\t英国\tUnited Kiongdom,GD\t格林纳达\tGrenada\t,GE\t格鲁吉亚\tGeorgia\t,GF\t法属圭亚那\tFrench Guiana,GH\t加纳\tGhana,GI\t直布罗陀\tGibraltar,GM\t冈比亚\tGambia\t,GN\t几内亚\tGuinea\t,GR\t希腊\tGreece,GT\t危地马拉\tGuatemala\t,GU\t关岛\tGuam,GY\t圭亚那\tGuyana,HK\t中国香港特别行政区\tHongkong,HN\t洪都拉斯\tHonduras,HT\t海地\tHaiti,HU\t匈牙利\tHungary,ID\t印度尼西亚\tIndonesia,IE\t爱尔兰\tIreland,IL\t以色列\tIsrael,IN\t印度\tIndia,IQ\t伊拉克\tIraq,IR\t伊朗\tIran,IS\t冰岛\tIceland,IT\t意大利\tItaly,CI\t科特迪瓦\tIvory Coast,JM\t牙买加\tJamaica,JO\t约旦\tJordan,JP\t日本\tJapan,KE\t肯尼亚\tKenya,KG\t吉尔吉斯坦\tKyrgyzstan,KH\t柬埔寨\tKampuchea (Cambodia ),KP\t朝鲜\tNorth Korea,KR\t韩国\tKorea,KW\t科威特\tKuwait,KZ\t哈萨克斯坦\tKazakstan,LA\t老挝\tLaos,LB\t黎巴嫩\tLebanon,LC\t圣卢西亚\tSt.Lucia,LI\t列支敦士登\tLiechtenstein,LK\t斯里兰卡\tSri Lanka,LR\t利比里亚\tLiberia,LS\t莱索托\tLesotho,LT\t立陶宛\tLithuania,LU\t卢森堡\tLuxembourg,LV\t拉脱维亚\tLatvia,LY\t利比亚\tLibya,MA\t摩洛哥\tMorocco,MC\t摩纳哥\tMonaco,MD\t摩尔多瓦\tMoldova, Republic of,MG\t马达加斯加\tMadagascar,ML\t马里\tMali,MM\t缅甸\tBurma,MN\t蒙古\tMongolia,MO\t中国澳门特别行政区\tMacao,MS\t蒙特塞拉特岛\tMontserrat Is,MT\t马耳他\tMalta,MP\t马里亚那群岛\tMariana Is,MQ\t马提尼克\tMartinique,MU\t毛里求斯\tMauritius,MV\t马尔代夫\tMaldives,MW\t马拉维\tMalawi,MX\t墨西哥\tMexico,MY\t马来西亚\tMalaysia,MZ\t莫桑比克\tMozambique,NA\t纳米比亚\tNamibia,NE\t尼日尔\tNiger,NG\t尼日利亚\tNigeria,NI\t尼加拉瓜\tNicaragua,NL\t荷兰\tNetherlands,NO\t挪威\tNorway,NP\t尼泊尔\tNepal,AN\t荷属安的列斯\tNetheriands Antilles,NR\t瑙鲁\tNauru,NZ\t新西兰\tNew Zealand,OM\t阿曼\tOman,PA\t巴拿马\tPanama,PE\t秘鲁\tPeru,PF\t法属玻利尼西亚\tFrench Polynesia,PG\t巴布亚新几内亚\tPapua New Cuinea,PH\t菲律宾\tPhilippines,PK\t巴基斯坦\tPakistan,PL\t波兰\tPoland,PR\t波多黎各\tPuerto Rico,PT\t葡萄牙\tPortugal,PY\t巴拉圭\tParaguay,QA\t卡塔尔\tQatar,RE\t留尼旺\tReunion,RO\t罗马尼亚\tRomania,RU\t俄罗斯\tRussia,SA\t沙特阿拉伯\tSaudi Arabia,SB\t所罗门群岛\tSolomon Is,SC\t塞舌尔\tSeychelles,SD\t苏丹\tSudan,SE\t瑞典\tSweden,SG\t新加坡\tSingapore,SI\t斯洛文尼亚\tSlovenia,SK\t斯洛伐克\tSlovakia,SL\t塞拉利昂\tSierra Leone,SM\t圣马力诺\tSan Marino,AS\t东萨摩亚(美)\tSamoa Eastern,WS\t西萨摩亚\tSan Marino,SN\t塞内加尔\tSenegal,SO\t索马里\tSomali,SR\t苏里南\tSuriname,ST\t圣多美和普林西比\tSao Tome and Principe,SV\t萨尔瓦多\tEI Salvador,SY\t叙利亚\tSyria,SZ\t斯威士兰\tSwaziland,TD\t乍得\tChad,TG\t多哥\tTogo,TH\t泰国\tThailand,TJ\t塔吉克斯坦\tTajikstan,TM\t土库曼斯坦\tTurkmenistan,TN\t突尼斯\tTunisia,TO\t汤加\tTonga,TR\t土耳其\tTurkey,TT\t特立尼达和多巴哥\tTrinidad and Tobago,TW\t中国台湾省\tTaiwan,TZ\t坦桑尼亚\tTanzania,UA\t乌克兰\tUkraine,UG\t乌干达\tUganda,US\t美国\tUnited States of America,UY\t乌拉圭\tUruguay\t,UZ\t乌兹别克斯坦\tUzbekistan\t,VC\t圣文森特岛\tSaint Vincent,VE\t委内瑞拉\tVenezuela,VN\t越南\tVietnam,YE\t也门\tYemen\t,YU\t南斯拉夫\tYugoslavia,ZA\t南非\tSouth Africa,ZM\t赞比亚\tZambia,ZR\t扎伊尔\tZaire,ZW\t津巴布韦\tZimbabwe`.split(',').map((item)=>{
        item = item.split('\t');
        return item[0] + '-' + item[1] + `(${item[2]})`
    });

    /**
     * 点击菜单中的某个config，展现某一条key的value
     * 并更新curKey
     * @param {*} key
     */
    async function showConfigItem(key, codeEditorRef) {
        const editor = codeEditorRef.current.editor;
        editor.setValue('');
        $("#" + key).addClass("clicked").siblings().removeClass("clicked");
        $("#config_item_lable").empty();
        $("#config_item_lable").html("Start get config ...");
        let platform = $("#platform_input").val();
        curKey = key;
        console.log(CurrentPlan);
        const different_setting = await queryDiffConfig(platform, CurrentPlan);
        $("#config_item_lable").html(curKey);

        // 获取差异化配置
        let content;
        if (different_setting && typeof different_setting === "object") {
            let hasDiffSetting = false;
            for (const setting of different_setting) {
                if (typeof setting === "object" && setting.platform_type === `${platform}##${curType}` && setting.setting_name === curKey) {
                    content = setting.setting_value;
                    differentSettingContent = JSON.stringify([setting]);
                    hasDiffSetting = true;
                    break;
                }
            }
            if (!hasDiffSetting) {
                differentSettingContent = ""
            }
        }

        database_config_content = JSON.stringify(tolConfig[curKey], null, 4);
        if (content) {
            content = JSON.stringify(content, null, 4);
            editor.setValue(content);
        }
    }

    /**
     * 获得某平台的某个差异化配置
     * 并且更新菜单
     * @param {*} platform
     * @param {*} settingName
     */
    async function queryDiffConfig(platform, settingName) {
        return new Promise(async (resolve, reject) => {
            const configType = 'special';
            if (!platform) {
                alert("缺少平台名");
                return;
            }

            let username = localStorage.getItem("username");
            let menuId = $("#menu_id").html();
            // 获得所有config
            $.ajax({
                type: "GET",
                url: "/api/v1/config/single_config?platform=" + platform + "&config_type=" + configType + "&setting_name=" + settingName + '&username=' + username + '&menuId=' + menuId,
                success: function(data) {
                    if (!data || data.err) {
                        if (data.isReload) {
                            window.location.href = "/login.html";
                            return;
                        }
                        alert("Query Failed：" + data.err);
                        reject(data.err);
                    } else {
                        resolve(data.data.setting_value);
                    }
                },
                error: function(req, status, err) {
                    const message = err.message || err;
                    alert("查询配置失败，网络出问题了，请稍后重试。错误原因:" + message);
                    reject(err);
                },
            });
        });
    }

    /**
     * 点击保存时，保存输入框中内容
     */
    async function save(codeEditorRef) {
        const editor = codeEditorRef.current.editor;
        let configValue = editor.getValue();
        if (!configValue && !differentSettingContent) {
            alert('特殊配置不能设置为空'); // 之前没有配置差异化配置，保存时发现editor内容为空
            return;
        }
        if (!curKey) {
            alert("请选择配置");
            return;
        }

        configValue = formatJson(configValue);

        try {
            configValue = JSON.parse(configValue);
        } catch (e) {
            configValue = configValue.trim();
        }

        if (configValue === '') {
            configValue = {}
        }

        if (typeof(configValue) !== "object") {
            alert('数据格式有误，请重新编辑');
            return;
        }

        let platform = $("#platform_input").val();
        const data = {
            "platform_type": `${platform}##${curType}`,
            "setting_name": curKey,
            "setting_value": configValue
        };

        //  校验配置
        const valid = await checkDiffContent();
        if (!valid) {
            return;
        }

        // 保存到数据库
        await updateConfig(curKey, data);
    }

    /**
     * 更新config的内容
     * @param {*} configKey
     * @param {*} configValue
     */
    async function updateConfig(configKey, configValue) {
        return new Promise(async (resolve, reject) => {
            let platform = $("#platform_input").val();
            let username = localStorage.getItem("username");
            if (!platform) {
                alert("请输入平台名");
                return;
            }
            let path = 'config';
            let old = await querySingleConfig(platform, "special", CurrentPlan);
            if (old) {
                path = 'update_config';
                let isUpdate = false;
                for (const setting of old) {
                    if (setting.platform_type === configValue.platform_type && setting.setting_name === configValue.setting_name) {
                        if (typeof configValue.setting_value === "object" && Object.keys(configValue.setting_value).length > 0) {
                            setting.setting_value = configValue.setting_value;  // 新配置覆盖老配置
                        } else {
                            delete old[old.indexOf(setting)];
                        }
                        isUpdate = true;
                        break;
                    }
                }
                if (!isUpdate) {
                    old.push(configValue)
                }
                old = old.filter((item) => {
                    return item !== undefined;
                });
                configValue = old
            } else {
                configValue = [configValue]
            }

            const settingName = CurrentPlan;
            const configType = "special";
            $.ajax({
                type: "POST",
                url: "/api/v1/config/" + path + "?username=" + username + "&menuId=setting",
                data: {
                    platform: platform,
                    config_type: configType,
                    setting_name: settingName,
                    setting_value: JSON.stringify(configValue),
                },
                success: function (data) {
                    if (!data || data.err) {
                        if (data.isReload) {
                            window.location.href = "/login.html";
                            return;
                        }
                        alert("提交失败：" + data.err);
                    } else {
                        alert("Change Success.");
                        $("#modal_off").click();
                        refresh();
                    }
                },
                error: function (req, status, err) {
                    const message = err.message || err;
                    alert("更新配置失败，网络出问题了，请稍后重试。错误原因:" + message);
                },
            });
        });
    }

/////////////////////////////////////////////////////////////////////////////////////
// 网络请求函数
/////////////////////////////////////////////////////////////////////////////////////

    /**
     * 获得某平台的某个configtype下的所有配置
     * 并且更新菜单
     * @param {*} platform
     * @param {*} configType
     */
    async function queryAll(platform, configType) {
        return new Promise(async (resolve, reject) => {
            if (!configType) {
                alert("缺少Type");
                return;
            }
            if (!platform) {
                alert("缺少平台名");
                return;
            }
            let username = localStorage.getItem("username");
            let menuId = $("#menu_id").html();
            // 获得所有config
            $.ajax({
                type: "GET",
                url: "/api/v1/config/content?platform=" + platform + "&config_type=" + configType + '&username=' + username + '&menuId=' + menuId,
                success: function(data) {
                    if (!data || data.err) {
                        if (data.isReload) {
                            window.location.href = "/login.html";
                            return;
                        }
                        alert("Query Failed：" + data.err);
                        return;
                    } else {
                        tolConfig = data.data[configType];
                        // 获得所有key组成的数组
                        let allKey = Object.keys(data.data[configType]);
                        resolve(allKey);
                    }
                },
                error: function(req, status, err) {
                    const message = err.message || err;
                    alert("查询配置失败，网络出问题了，请稍后重试。错误原因:" + message);
                },
            });
        });
    }

    function onSearchPlatformAutoComplete (txt) {
        const filterPlatforms = allPlatformList.filter((platform) => {
            return platform.toLowerCase().indexOf(txt.toLowerCase()) > -1;
        });
        setPlatformAutoComplete(filterPlatforms.map((platform) => {
            return {value: platform};
        }));
    }

    /**
     * 拉取所有平台名称
     * @returns {Promise<void>}
     */
    async function queryAllPlatform() {
        let username = localStorage.getItem("username");
        let menuId = $("#menu_id").html();
        $.ajax({
            type: "GET",
            url: "/api/v1/config/platform" + '?username=' + username + '&menuId=' + menuId,
            success: function(data) {
                if (data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                    } else {
                        alert(data.err);
                    }
                    return;
                }
                data = data.data;
                if (data && data.length) {
                    /* data.sort(function(a, b) {
                         return a.timestamp - b.timestamp;
                     });*/

                    let allPlatform = [];
                    for (let p of data) {
                        allPlatform.push(p);
                    }
                    allPlatformList = allPlatform;
                    // $("#platform_input").autocomplete({
                    //     source: allPlatform,
                    // });

                }
            },
            error: function(req, status, err) {
                const message = err.message || err;
                alert("查询失败，网络出问题了，请稍后重试。错误原因:" + message);
            },
        });
    }

    /**
     * 格式化JSON
     */
    function formatJson(content) {
        if (!content) {
            return "";
        }
        try {
            content = JSON.parse(content);
        } catch (e) {
            content = content.replace(/\s/g, "");
            try {
                const objJsonParsed = content.includes("{") && content.includes("}");
                const arrayJsonParsed = content.includes("[") && content.includes("]");
                const numberJsonParsed = content.match(new RegExp(/^[0-9]*$/));
                if (objJsonParsed || arrayJsonParsed || numberJsonParsed) {
                    content = JSON.parse(content);
                }
            } catch (e) {
                alert("数据格式有误，请重新编辑!");
                return;
            }
        }
        if (typeof(content) == "object") {
            content = JSON.stringify(content, null, 4);
        }
        if (typeof (content) === "number") {
            content = content.toString();
        }
        return content;
    }

    function diffUsingJS(old_content, new_content, display_diff_div_obj, view_type) {
        setBaseConfigValue(old_content);
        setSpecialConfigValue(new_content);
        setSplitView(!view_type);
    }

    $("li").click(function() {
        $(this).addClass("clicked").siblings().removeClass("clicked");
    });

    async function previewGroupConfig () {
        let platform = $("#platform_input").val();
        let data = {};
        try {
            data = await coverGroupConfig(platform, CurrentPlan);
        } catch (e) {
            alert(e);
            return;
        }
        diffUsingJS(JSON.stringify(data.base, null, 4), JSON.stringify(data.diff, null, 4), $("#diffoutput"), 0);
        $("#text_diff_modal_group").css({
            "width": "90%",
            "margin-left": "5%",
            "height": "95%",
            "margin-top": "-70px",
            "background-color": "white",
            "top": "90px",
            "position": "fixed",
            "overflow-x": "auto",
        });
        $(".subject").css({
            "position": "relative",
            "left": "-50%",
        });
        $("#text_diff_modal_group div.modal-body").css({
            "max-height": "100%",
            "padding-bottom": "20px",
        });
        $("#text_diff_modal_group div.modal-header").css({
            "margin": "0 auto",
        });

        $("#diffoutput_group").css({
            "max-height": window.screen.availHeight - 120 + "px",
        });
        $("#diffoutput_group table").css({
            "margin": "0 auto",
        });
        $("#text_diff_modal_group").modal();
    }

    async function btnOnCheckSubmit (codeEditorRef) {
        const editor = codeEditorRef.current.editor;
        if (editor.getValue() || differentSettingContent) {

            const coverSetting = await checkDiffContent();

            if (coverSetting && coverSetting[curType] && coverSetting[curType][curKey]) {

                const curSetting = coverSetting[curType][curKey];
                ContentInModal = JSON.stringify(curSetting, null, 4);
                console.log(ContentInModal, database_config_content);
                diffUsingJS(database_config_content, ContentInModal, $("#diffoutput"), 0);
                $("#text_diff_modal").css({
                    "width": "80%",
                    "margin-left": "10%",
                    "height": "95%",
                    "margin-top": "-70px",
                    "background-color": "white",
                    "top": "90px",
                    "position": "fixed",
                    "overflow-x": "auto",
                });
                $(".subject").css({
                    "position": "relative",
                    "left": "-50%",
                });
                $("#text_diff_modal div.modal-body").css({
                    "max-height": "100%",
                    "padding-bottom": "20px",
                });
                $("#text_diff_modal div.modal-header").css({
                    "margin": "0 auto",
                });

                $("#diffoutput").css({
                    "max-height": window.screen.availHeight - 120 + "px",
                });
                $("#diffoutput table").css({
                    "margin": "0 auto",
                });
                $("#text_diff_modal").modal();
            }
        } else {
            if (!editor.getValue()) {
                alert('缺参数!')
            }
        }
    }


    async function checkDiffContent() {
        const editor = codeEditorRef.current.editor;
        // 单个配置预览时，把他覆盖到原配置中再跟原配置比较
        const type_arr = ['common', 'client'];
        const content = {};
        const platform = $("#platform_input").val();

        for (const configType of type_arr) {
            try {
                const data = await queryAllConfigContent(platform, configType);
                content[configType] = data.data[configType];
            } catch (e) {
                console.log(e);
            }
        }
        let coverSetting;
        let data;
        if (editor.getValue()) {
            try {
                data = {
                    "platform_type": `${platform}##${curType}`,
                    "setting_name": curKey,
                    "setting_value": JSON.parse(editor.getValue())
                };
            } catch (e) {
                alert("数据格式有误，请重新输入");
                return;
            }
        } else {
            return content; // 配置设置为空时，表示删除，返回基础配置
        }

        try {
            coverSetting = await coverConfig(JSON.parse(JSON.stringify(content)), [data]);
        } catch (e) {
            alert(e);
            return;
        }
        return coverSetting
    }


    async function queryAllConfigContent(platform, configType) {
        return new Promise(async (resolve, reject) => {
            let username = localStorage.getItem("username");
            let menuId = $("#menu_id").html();
            // 获得所有config
            $.ajax({
                type: "GET",
                url: "/api/v1/config/content?platform=" + platform + "&config_type=" + configType + '&username=' + username + '&menuId=' + menuId,
                success: function(data) {
                    if (!data || data.err) {
                        if (data.isReload) {
                            window.location.href = "/login.html";
                            return;
                        }
                        alert("Query Failed：" + data.err);
                        return;
                    } else {
                        resolve(data);
                    }
                },
                error: function(req, status, err) {
                    const message = err.message || err;
                    alert("查询配置内容失败，网络出问题了，请稍后重试。错误原因:" + message);
                },
            });
        });
    }

    /**
     * 获得某平台的某个configtype下的单个配置
     * @param {*} platform
     * @param {*} configType
     * @param {*} settingName
     */
    async function querySingleConfig(platform, configType, settingName) {
        return new Promise(async (resolve, reject) => {
            let username = localStorage.getItem("username");
            let menuId = $("#menu_id").html();
            // 获得所有config
            $.ajax({
                type: "GET",
                url: "/api/v1/config/single_config?platform=" + platform + "&config_type=" + configType + "&setting_name=" + settingName + '&username=' + username + '&menuId=' + menuId,
                success: function(data) {
                    if (!data || data.err) {
                        if (data.isReload) {
                            window.location.href = "/login.html";
                            return;
                        }
                        if (data === undefined) {
                            resolve({})
                        }
                        alert("Query Failed：" + data.err);
                        reject(data.err);
                    } else {
                        resolve(data.data.setting_value);
                    }
                },
                error: function(req, status, err) {
                    console.log("request failed.[err: " + err + "]", status, req);
                    reject(err);
                },
            });
        });
    }

    async function coverConfig (configRaw, configDiffs) {
        return new Promise(async (resolve, reject) => {
            if (!(configRaw && configDiffs)) {
                alert("缺参数");
                return;
            }
            let username = localStorage.getItem("username");
            let menuId = $("#menu_id").html();
            $.ajax({
                type: "POST",
                url: "/api/v1/diff_config/cover_config?platform="  + '&username=' + username + '&menuId=' + menuId,
                data: {
                    baseConfig: JSON.stringify(configRaw),
                    diffConfig: JSON.stringify(configDiffs)
                },
                success: function(data) {
                    if (!data || data.err) {
                        if (data.isReload) {
                            window.location.href = "/login.html";
                            return;
                        }
                        reject(data.err);
                    } else {
                        resolve(data.data);
                    }
                },
                error: function(req, status, err) {
                    const message = err.message || err;
                    alert("覆盖配置失败，网络出问题了，请稍后重试。错误原因:" + message);
                },
            });
        });
    }

    async function coverGroupConfig (platform, plan_name) {
        return new Promise(async (resolve, reject) => {
            if (!(platform && plan_name)) {
                alert("缺参数");
                return;
            }
            let username = localStorage.getItem("username");
            let menuId = $("#menu_id").html();
            $.ajax({
                type: "POST",
                url: "/api/v1/diff_config/preview_group_config?platform="  + '&username=' + username + '&menuId=' + menuId,
                data: {
                    platform: platform,
                    plan_name: plan_name
                },
                success: function(data) {
                    if (!data || data.err) {
                        reject(data.err);
                    }  else {
                        resolve(data.data);
                    }
                },
                error: function(req, status, err) {
                    const message = err.message || err;
                    alert("覆盖整个分组配置失败，网络出问题了，请稍后重试。错误原因:" + message);
                },
            });
        });
    }


    function initGroupData(af_status, campain_id, channels, country, vipList, dbPlanGroups, alias='') {

        $("#combox1").combox({
            id: "id",
            name: "text",
            data: af_status,
        });
        $("#combox2").combox({
            id: "id",
            name: "text",
            data: campain_id,
            valueChange:function(data){
                // debugger
                const selectedData = data.selectData;
                const selectedMedias = [];
                for (const data of selectedData) {
                    const campaign = data.id;
                    const parent = ConversionInfos.campaign_id[campaign].parents[0];
                    selectedMedias.push(parent)
                }
                const medias = Object.keys(ConversionInfos.media_source).map((item) => {
                    return {id: item, text: item}
                });
                for (const media of medias) {
                    if (selectedMedias.includes(media.id)) {
                        if (!$("#"+ media.id).hasClass("checked")) {
                            $("#"+ media.id).mousedown();
                        }
                    }
                }
            }
        });
        $("#combox3").combox({
            id: "id",
            name: "text",
            data : channels,
            valueChange:function(data){
                // debugger
                const selectedData = data.selectData;
                const selectedAfs = [];
                for (const data of selectedData) {
                    const media = data.id;
                    const parent = ConversionInfos.media_source[media].parents[0];
                    selectedAfs.push(parent)
                }
                const afInfos = Object.keys(ConversionInfos.af_status).map((item) => {
                    return {id: item, text: item}
                });
                for (const af of afInfos) {
                    if (selectedAfs.includes(af.id)) {
                        if (!$("#"+af.id).hasClass("checked")) {
                            $("#"+af.id).mousedown();
                        }
                    }
                }
            }
        });
        $("#combox4").combox({
            id: "id",
            name: "text",
            data: country,
        });
        $("#combox5").singleCombox({
            id: "id",
            name: "text",
            data: vipList,
        });
        console.log('dbPlanGroups', dbPlanGroups)
        $("#combox6").singleCombox({
            id: "id",
            name: "text",
            data : dbPlanGroups
        });
        $(".combox").removeAttr("readonly");
        $("#alias_input").val(alias)
    }


    function save_diff_setting_user_group() {
        let af_status = $("#combox1").data('combox').options.selectData;
        let campain_id = $("#combox2").data('combox').options.selectData;
        let media_source = $("#combox3").data('combox').options.selectData;
        let country = $("#combox4").data('combox').options.selectData;
        let isVip = $("#combox5").data('combox').options.selectData;
        let parentPlans = $("#combox6").data('combox').options.selectData;

        let alias = $("#alias_input").val()

        // const campaign_t = $(":input[name='campaign_t']:checked").val();
        const country_t = $(":input[name='country_t']:checked").val();

        let groupInfo = {};

        function getValue(l) {
            return l.map((item) => {
                return item.id
            })
        }
        if (af_status.length > 0) {
            groupInfo.af_status = getValue(af_status);
        }
        if (media_source.length > 0) {
            groupInfo.media_source = getValue(media_source);
        }
        if (campain_id.length > 0) {
            groupInfo.campaign_id = getValue(campain_id);
        }
        if (country.length > 0) {
            groupInfo.country = getValue(country);
        }
        if (isVip.length === 1) {
            groupInfo.vip = getValue(isVip);
        }
        if (isVip.length > 1) {
            alert('Vip选项只能选择是或否');
            return;
        }

        if (parentPlans.length > 0) {
            groupInfo.parent_plan = getValue(parentPlans)[0];
        } else {
            alert('必须配置依赖分组');
            return
        }

        if (alias) {
            groupInfo.alias = alias;
        }

        // if (campaign_t === 'negative') {
        //     groupInfo.campaign_id = groupInfo.campaign_id.map((item) => {
        //         return '!' + item;
        //     })
        // }

        if (country_t === 'negative') {
            groupInfo.country = groupInfo.country.map((item) => {
                return '!' + item;
            })
        }

        const platform = $("#platform_input").val();
        const plan = CurrentPlan;
        if (!platform || !plan || Object.keys(groupInfo).length === 0) {
            alert('lack plan、platform or group_info');
            return
        }
        console.log(groupInfo);
        let username = localStorage.getItem("username");
        $.ajax({
            type: "POST",
            url: "/api/v1/config/add_diff_setting_user_group_v2/" + "?username=" + username + "&menuId=setting" + `&platform=${platform}` + `&plan=${plan}`,
            data: {groupInfo},
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                }
                else if (data.status === 200) {
                    alert("提交成功.");
                }
                else if (data.status === 400) {
                    alert('提交失败: lack plan、 platform or group_info')
                }
                else {
                    alert("提交失败: plan重复绑定或其他错误")
                }
                refresh_different_setting_group();
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("保存用户分组失败，网络出问题了，请稍后重试。错误原因:" + message);
                refresh_different_setting_group();
            },
        });
    }

    function refresh_different_setting_group() {
        $("#userGroupSelect").show();
        $("#edit_different_setting_group").show();
        $("#submit_different_setting_user_group").show();

        const platform = $("#platform_input").val();
        if (!platform) {
            alert("请选择platform");
            return;
        }
        let username = localStorage.getItem("username");

        $.ajax({
            type: "GET",
            url: "/api/v1/config/get_diff_setting_user_groups/"+ "?username=" + username + "&menuId=setting" + `&platform=${platform}`,
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                } else if (data.status === 200) {
                    DiffSettingUserGroups = data.groups;
                    initCombox();
                    let group = {};
                    for (const userGroup of DiffSettingUserGroups) {
                        if (userGroup.plan_name === CurrentPlan) {
                            group = userGroup;
                            break;
                        }
                    }

                    const plans = data.groups.map((group) => {
                        return {title: `${group.plan_name}-${group.alias}`, key: group.plan_name};
                    });
                    setTabPlans({activeKey: CurrentPlan, panes: plans});

                    showGroupDiff(group)
                } else {
                    alert("查询用户分组，网络出问题了，请稍后重试.");
                }
            },
            error: function (req, status, err) {
                alert("request failed.[err: " + err + "]  ಠ_ಠ");
            },
        });
        init_switch();
        $("#switch_mod").show();
        $("#different_config_group").show()
    }


    function showGroupDiff(userGroup) {
        const groupInfo = userGroup.group_info;
        // let campaign_t = 'positive';
        let country_t = 'positive';
        // if (groupInfo.campaign_id && groupInfo.campaign_id.length > 0) {
        //     for (const campaign_id of groupInfo.campaign_id) {
        //         if (campaign_id.indexOf('!') > -1) {
        //             campaign_t = 'negative';
        //             const index = groupInfo.campaign_id.indexOf(campaign_id);
        //             groupInfo.campaign_id[index] = campaign_id.replace('!', '');
        //         }
        //     }
        // }
        if (groupInfo && groupInfo.country && groupInfo.country.length > 0) {
            for (const country of groupInfo.country) {
                if (country.indexOf('!') > -1) {
                    country_t = 'negative';
                    const index = groupInfo.country.indexOf(country);
                    groupInfo.country[index] = country.replace('!', '');
                }
            }
        }

        // if (campaign_t === 'negative') {
        //     $(":input[name='campaign_t']")[1].click();
        // } else {
        //     $(":input[name='campaign_t']")[0].click();
        // }

        if (country_t === 'negative') {
            $(":input[name='country_t']")[1].click();
        } else {
            $(":input[name='country_t']")[0].click();
        }

        let username = localStorage.getItem("username");
        const platform = $("#platform_input").val();
        if (!platform) {
            alert('请选择platform');
            return;
        }
        $.ajax({
            type: "GET",
            url: "/api/v1/config/get_diff_setting_af_infos" + "?username=" + username + "&menuId=setting" + `&platform=${platform}`,
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("request failed：" + data.err);
                }
                else if (data.status === 200) {
                    ConversionInfos = data.data.afInfos;
                    const af_status = Object.keys(data.data.afInfos.af_status).map((item) => {
                        return {id: item, text: item}
                    });
                    const media_source = Object.keys(data.data.afInfos.media_source).map((item) => {
                        return {id: item, text: item + `(${data.data.afInfos.media_source[item].parents[0]})`}
                    });
                    const campaign_id = Object.keys(data.data.afInfos.campaign_id).map((item) => {
                        return {id: item, text: item + `(${data.data.afInfos.campaign_id[item].parents[0]})`}
                    });
                    const country = Country.map((item) => {
                        const splitItem = item.split('-');
                        return {id: splitItem[0], text: splitItem[1]}
                    });
                    const vipList = [{id: '0', text: '否'}, {id: '1', text: '是'}];

                    for (const af of af_status) {
                        if (groupInfo && groupInfo.af_status && groupInfo.af_status.includes(af.id)) {
                            af.checked = true
                        }
                    }
                    for (const af of campaign_id) {
                        if (groupInfo && groupInfo.campaign_id && groupInfo.campaign_id.includes(af.id)) {
                            af.checked = true
                        }
                    }
                    for (const af of media_source) {
                        if (groupInfo && groupInfo.media_source && groupInfo.media_source.includes(af.id)) {
                            af.checked = true
                        }
                    }
                    for (const ct of country) {
                        if (groupInfo && groupInfo.country && groupInfo.country.includes(ct.id)) {
                            ct.checked = true
                        }
                    }
                    for (const v of vipList) {
                        if (groupInfo && groupInfo.vip && groupInfo.vip.includes(v.id)) {
                            v.checked = true
                        }
                    }

                    const dbPlanGroups = []
                    for (const group of DiffSettingUserGroups) {
                        if (group.plan_name !== userGroup.plan_name) {
                            dbPlanGroups.push({id: group.plan_name, text: group.plan_name})
                        }
                    }

                    let hasParent = false
                    for (const group of dbPlanGroups) {
                        if (userGroup && userGroup.parent_plan && userGroup.parent_plan === group.id ) {
                            group.checked = true
                            hasParent = true
                            break
                        }
                    }
                    if (hasParent) {
                        dbPlanGroups.splice(0, 0, {id: 'base', text: 'base'})
                    } else {
                        dbPlanGroups.splice(0, 0, {id: 'base', text: 'base', checked: true})
                    }

                    initGroupData(af_status, campaign_id, media_source, country, vipList, dbPlanGroups, userGroup.alias)
                }
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("展示用户分组失败，网络出问题了，请稍后重试。错误原因:" + message);
            },
        });
    }


    function initCombox() {
        $("#userGroupSelect").empty();
        $("#userGroupSelect").append(
            `<div class="card" style="width: 100%;position: relative">
            <div style="height: 50px;">
                af_status: <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="af_status" id="combox1" autocomplete="off">
            </div>
            <div style="height: 50px;">
                media_source: <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="media_source" id="combox3" autocomplete="off">
            </div>
            <div style="height: 50px;">
                campain_id: <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="campain_id" id="combox2" autocomplete="off">
            </div>
            <div style="height: 50px;">
                country: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;<input type="radio" checked="checked"  name="country_t" value="positive"> 正选 &nbsp;<input type="radio" name="country_t" value="negative"> 反选 <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="country" id="combox4" autocomplete="off">
            </div>
            <div style="height: 50px;">
                VIP: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;<input class="combox" style="position: absolute;left: 300px; width: 400px;" name="vip" id="combox5" autocomplete="off">
            </div>
            <div style="height: 50px;">
                依赖分组: <input class="combox" style="position: absolute;left: 300px; width: 400px;" name="parent_plan" id="combox6" autocomplete="off">
            </div>
            <div style="height: 50px;">
                分组别名: <input class="" style="position: absolute;left: 300px; width: 400px;" name="group_alias" id="alias_input" autocomplete="off">
            </div>
        </div>`
        )
    }

    function init_switch() {
        let platform = $("#platform_input").val();
        if (!platform) {
            alert("请选择platform");
            return;
        }

        // 获取switch
        let username = localStorage.getItem("username");

        $.ajax({
            type: "GET",
            url: "/api/v1/config/get_diff_setting_switch/"+ "?username=" + username + "&menuId=setting" + `&platform=${platform}`,
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                } else if (data.status === 200) {
                    console.log(data);
                    console.log(data.data.switch);
                    const icon = $("#switch-icon");
                    if (data.data.switch === 'on') {
                        $('#switch-text').html('已启用');
                        if (icon.hasClass("fa-toggle-off")) {
                            icon.removeClass("fa-toggle-off");
                            icon.addClass("fa-toggle-on")
                        }
                        $("#switch").val("on");
                        $("#confirm").html("特殊配置已启用，是否要停用？")
                    } else {
                        $('#switch-text').html('已停用');
                        if (icon.hasClass("fa-toggle-on")) {
                            icon.removeClass("fa-toggle-on");
                            icon.addClass("fa-toggle-off")
                        }
                        $("#switch").val("off");
                        $("#confirm").html("特殊配置已停用，是否要启用？");
                    }
                } else {
                    alert("request failed");
                }
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("查询差异化配置开关，网络出问题了，请稍后重试。错误原因:" + message);
            },
        });
    }

    function swtichStatus() {
        let platform = $("#platform_input").val();
        if (!platform) {
            platform = $("#platform_input").val();
        }
        if (!platform) {
            alert("请选择platform");
            return;
        }

        let switchStatus = $("#switch").val();
        switchStatus = switchStatus === 'on' ? 'off' : 'on';

        // 获取switch
        let username = localStorage.getItem("username");

        $.ajax({
            type: "POST",
            url: "/api/v1/config/diff_setting_switch/"+ "?username=" + username + "&menuId=setting" + `&platform=${platform}`,
            data: {switchStatus},
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                } else if (data.status === 200) {
                    init_switch()
                } else {
                    alert(data.message);
                }
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("开启或者停用差异化配置失败，网络出问题了，请稍后重试。错误原因:" + message);
            },
        });
    }

    function getDiffHistory() {
        let platform = $("#platform_input").val();
        if (!platform) {
            alert("请选择platform");
            return;
        }

        // 获取switch
        let username = localStorage.getItem("username");

        $.ajax({
            type: "GET",
            url: "/api/v1/config/diff_setting_history/"+ "?username=" + username + "&menuId=setting" + `&platform=${platform}`,
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                } else if (data.status === 200) {
                    $('#historyDiv').empty();
                    let history = data.data;
                    console.log(history);
                    history = history.filter((log) => {
                        return log.setting_name === CurrentPlan;
                    });
                    console.log(history);
                    let html = '<table border="1" style="width: 100%"><tr>' +
                        '<th>修改时间</th>' +
                        '<th>修改内容</th>' +
                        '</tr>';
                    for (const his of history) {
                        let content = JSON.parse(his.setting_value);
                        // 展示差异化配置
                        let showContent = {};
                        for (const setting of content) {
                            const key = setting.platform_type.split("##")[1] + "." + setting.setting_name;
                            showContent[key] = setting.setting_value;
                        }
                        html += `<tr><th>${new Date(his.timestamp).toLocaleString().replace(/:\d{1,2}$/,' ')}</th><th><p><pre>${JSON.stringify(showContent, null, 4)}</pre></p></th>`
                    }
                    html += '</table>';
                    $('#historyDiv').append(html);
                    $("#diff_history_modal").css({
                        "width": "80%",
                        "margin-left": "10%",
                        "height": "95%",
                        "margin-top": "-70px",
                        "background-color": "white",
                        "top": "90px",
                        "position": "fixed",
                        "overflow-x": "auto",
                    });
                    $("h3").css({
                        "position": "relative",
                    });
                    $("#diff_history_modal div.modal-body").css({
                        "max-height": "100%",
                        "padding-bottom": "20px",
                    });
                    $("#historyDiv").css({
                        "max-height": window.screen.availHeight - 120 + "px",
                    });
                    $("#diff_history_modal").modal();
                } else {
                    alert("request failed");
                }
            },
            error: function (req, status, err) {
                const message = err.message || err;
                alert("查询差异化配置修改记录，网络出问题了，请稍后重试。错误原因:" + message);
            },
        });
    }

    async function refresh() {
        let platform = $("#platform_input").val();
        let allKey = await queryAll(platform, curType);
        // buildMenu(allKey, "configList");
        setConfigListData(allKey);
        if (curKey) {
            $("#" + curKey).addClass("clicked").siblings().removeClass("clicked");
            showConfigItem(curKey, codeEditorRef);
        }
        init_switch();
        await refresh_different_setting_group();
        await refreshPlan()
    }

    async function tabChange(type) {
        const editor = codeEditorRef.current.editor;
        // $("#configList").empty();
        $("#config_item_lable").empty();
        editor.setValue("");
        curType = type;
        curKey = "";
        let platform = $("#platform_input").val();
        // 如果有平台名就query，没平台名就正常跳转
        if (platform) {
            let allKey = await queryAll(platform, curType);
            // buildMenu(allKey, "configList");
            setConfigListData(allKey);
            if (curKey) {
                $("#" + curKey).addClass("clicked").siblings().removeClass("clicked");
            }
        }
    }

    async function addPlanBtn() {
        const { panes, activeKey } = tabPlans;
        console.log('addPlan', tabPlans);
        const lastPlan = panes[panes.length - 1].key.split('plan')[1];
        const planIndex = Plans.split('').indexOf(lastPlan);
        const newPlan = 'plan' + Plans.split('')[planIndex+1];
        const newPanes = [...panes];
        newPanes.push({ title: newPlan, key: newPlan });
        setTabPlans({
            panes: newPanes,
            activeKey,
        });
    }

    async function planTabChange(plan) {
        CurrentPlan = plan;
        database_config_content = "";
        differentSettingContent = "";
        DiffSettingUserGroups = [];
        ConversionInfos = null;
        ContentInModal = '';
        await refresh_different_setting_group();
        const { panes } = tabPlans;
        console.log(CurrentPlan)
        setTabPlans({activeKey: plan, panes})
    }

    async function refreshPlan() {
        const platform = $("#platform_input").val();
        if (!platform) {
            alert("请选择platform");
            return;
        }
        let username = localStorage.getItem("username");

        $.ajax({
            type: "GET",
            url: "/api/v1/config/get_diff_setting_user_groups/"+ "?username=" + username + "&menuId=setting" + `&platform=${platform}`,
            success: function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("提交失败：" + data.err);
                } else if (data.status === 200) {
                    DiffSettingUserGroups = data.groups;
                    console.log(DiffSettingUserGroups);
                    const plans = data.groups.map((group) => {
                        return {title: `${group.plan_name}-${group.alias}`, key: group.plan_name};
                    });
                    setTabPlans({activeKey: CurrentPlan, panes: plans});
                } else {
                    alert("request failed");
                }
            },
            error: function (req, status, err) {
                alert("request failed.[err: " + err + "]  ಠ_ಠ");
            },
        });
    }

    async function delPlan (plan) {
        const platform = $("#platform_input").val();
        if (!platform) {
            alert("请选择platform");
            return;
        }

        const { panes, activeKey } = tabPlans;
        let newActiveKey = activeKey;
        let lastIndex = 0;
        panes.forEach((pane, i) => {
            if (pane.key === plan) {
                lastIndex = i - 1;
            }
        });
        const newPanes = panes.filter(pane => pane.key !== plan);
        if (newPanes.length && newActiveKey === plan) {
            if (lastIndex >= 0) {
                newActiveKey = newPanes[lastIndex].key;
            } else {
                newActiveKey = newPanes[0].key;
            }
        }
        console.log('delPlan', tabPlans);
        setTabPlans({activeKey: newActiveKey, panes: newPanes})

        let username = localStorage.getItem("username");

        $.ajax({
            type: "POST",
            url: "/api/v1/config/del_diff_user_group/"+ "?username=" + username + "&menuId=setting" + `&platform=${platform}`,
            data: {plan},
            success: async function (data) {
                if (!data || data.err) {
                    if (data.isReload) {
                        window.location.href = "/login.html";
                        return;
                    }
                    alert("删除差异化配置失败：" + data.err);
                } else if (data.status === 200) {
                    alert('删除差异化配置成功');
                    await refresh()
                } else if (data.status === 403) {
                    alert('只支持删除下架App VIP用户特殊配置');
                } else if (data.status === 404) {
                    alert('分组不存在');
                } else {
                    alert("request failed");
                }
                await refreshPlan();
            },
            error: function (req, status, err) {
                alert("request failed.[err: " + err + "]  ಠ_ಠ");
            },
        });
    }

    async function planChange (targetKey, action) {
        if (action === 'add') {
            await addPlanBtn();
        } else {
            await delPlan(targetKey)
        }
    }

    useEffect(() => {
        $(".CodeMirror-scroll").hover(function() {
            $(this).get(0).style.cursor = "text";
        });
        codeEditorRef.current.editor.setSize('auto', 'auto');
        queryAllPlatform();
    }, []);

    return (
        <div id="different-setting-component">
            <div className="page-wrapper" style={{overflowAnchor: 'none', marginTop: '20px'}}>
                <div className="row page-titles">
                    <div className="col-md-5 align-self-center">
                        <h3 className="text-info" style={{display: 'inline-block'}}>
                            差异化配置
                        </h3>
                        {/*<input id="platform_input" type="text" className="form-control input-rounded" placeholder="platform" style={{height: 30, width: 200, fontSize: 'small', position: 'relative', left: 100, top: 3}} />*/}
                        <AutoComplete
                            options={platformAutoComplete}
                            style={{
                                width: 200,
                                left: 200
                            }}
                            id="platform_input"
                            onSearch={onSearchPlatformAutoComplete}
                            placeholder="platform"
                        />
                        <button id="btn_refresh" className="btn btn-info btn-flat m-b-10 " type="button" style={{width: 40, height: 40, position: 'absolute', left: 750}} onClick={refresh.bind(this)}>
                            <i className="fa fa-refresh">
                            </i>
                        </button>
                        <button id="history" className="btn btn-info btn-flat m-b-10 " type="button" style={{width: 40, height: 40, position: 'absolute', left: 850}} onClick={getDiffHistory.bind(this)}>
                            <i className="fa fa-history">
                            </i>
                        </button>
                    </div>
                    <div className="col-md-7 align-self-center">
                    </div>
                </div>

                <div className="container-fluid">
                    <Tabs
                        type="editable-card"
                        onChange={planTabChange}
                        activeKey={tabPlans.activeKey}
                        onEdit={planChange}
                    >
                        {tabPlans.panes.map(pane => {
                            if (pane.title === 'planA') {
                                return (<TabPane tab={pane.title} key={pane.key} closable={false}>
                                </TabPane>)
                            } else {
                                return (<TabPane tab={pane.title} key={pane.key} closable={pane.closable}>
                                </TabPane>)
                            }
                        })}
                    </Tabs>
                </div>

                <div className="container-fluid" style={{overflowX: 'scroll'}}>
                    <ul className="nav nav-tabs customtab2" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active show" data-toggle="tab" href="#Pane" role="tab" aria-selected="true" onClick={tabChange.bind(this, 'client')}>
                                <span className="hidden-xs-down" style={{fontSize: 'small'}}>
                                  Client
                                </span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-toggle="tab" href="#Pane" role="tab" aria-selected="false" onClick={tabChange.bind(this, 'common')}>
                                <span className="hidden-xs-down" style={{fontSize: 'small'}}>
                                  Common
                                </span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link " data-toggle="tab" id="different_config_group_tab" href="#op_different_setting_group" role="tab" aria-selected="false">
                                <span className="hidden-xs-down" style={{fontSize: 'small'}}>
                                  用户分组
                                </span>
                            </a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link " data-toggle="tab" id="preview_plan" onClick={previewGroupConfig.bind(this)} href="#" role="tab" aria-selected="false">
                                  <span style={{fontSize: 'small'}}>
                                    预览当前分组配置
                                  </span>
                            </a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link " data-toggle="tab" id="switch_tab" href="#op_switch_btn" role="tab" aria-selected="false">
                                <span className="hidden-xs-down" style={{fontSize: 'small'}}>
                                  开关
                                </span>
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content" style={{minWidth: 1296}}>
                        <div className="tab-pane active show" id="Pane" role="tabpanel" style={{overflowX: 'hidden', overflowY: 'hidden'}}>
                            <div id="change-col" className="col">
                                <div className="inbox-leftbar">
                                    <div>
                                        <div id="newConfigItem" type="text" style={{height: 30, width: 150, fontSize: 'medium', position: 'relative'}}>
                                            config:
                                        </div>
                                    </div>
                                    <div className="mail-list mt-4" style={{borderRadius: '.9rem', background: 'white', position: 'relative', top: '-30px'}}>
                                        <div id="configList" style={{position: 'relative', top: 50, textAlign: 'center', minHeight: 300}}>
                                            {(() => {
                                                return configListData.map((item) => {
                                                    return (
                                                        <li
                                                            id={item}
                                                            key={item}
                                                            onClick = {showConfigItem.bind(this, item, codeEditorRef)}
                                                            style = {{height: '35px'}} >
                                                                < a href = "#" style={{fontSize: 'small', color: 'black'}} >{item}</a>
                                                        </li>
                                                    )
                                                });
                                            })()}
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{width: '70%', marginLeft: 20}}>
                                    <div className="card" style={{width: '100%', height: 80, position: 'relative'}}>
                                        <div className="row">
                                            <p id="write_status" style={{position: 'relative', top: 10, left: 50, fontSize: 'small'}}>
                                                Config Item:
                                                <span id="config_item_lable">
                                                </span>
                                            </p>
                                            <div className="dropdown" style={{position: 'absolute', left: 650}} id="after">
                                                <button id="btn_check" className="btn btn-info btn-flat m-b-10 " type="button" onClick={btnOnCheckSubmit.bind(this, codeEditorRef)}>
                                                      <span style={{fontSize: 'small', color: '#fff'}}>
                                                        校验
                                                      </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{width: '70%', marginLeft: 20}}>
                                    <div className="card" style={{width: '100%', position: 'relative'}}>
                                        <div>
                                            <CodeMirror
                                                id="code"
                                                className="config_content"
                                                ref={codeEditorRef}
                                                value=''
                                                options={{
                                                    mode: 'application/ld+json',
                                                    lineNumbers: true,
                                                    indentUnit: 4
                                                }}
                                                onChange={(editor, data, value) => {
                                                    //
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane p-20" id="op_different_setting_group" role="tabpanel" style={{overflowX: 'hidden', overflowY: 'hidden'}}>
                            <div id="different_config_group" style={{display: 'none'}} className="col">
                                <div id="userGroupSelect" className="row" style={{width: '70%', marginLeft: 20, display: 'none'}}>
                                </div>
                                <div className="row" style={{width: '70%', marginLeft: 20}}>
                                    <div className="card" style={{width: '100%', height: 80, position: 'relative'}}>
                                        <div className="row">
                                            <button id="submit_different_setting_user_group" className="btn btn-info btn-flat m-b-10 " type="button" style={{width: 80, height: 40, position: 'absolute', left: 400}} onClick={save_diff_setting_user_group.bind(this)}>
                                                保存
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane p-20" id="op_switch_btn" role="tabpanel" style={{overflowX: 'hidden', overflowY: 'hidden'}}>
                            <div id="switch_mod" style={{display: 'none'}} className="col">
                                <div id="confirm" className="row" style={{width: '70%', marginLeft: 20}}>
                                </div>
                                <div className="row" style={{width: '70%', marginLeft: 20}}>
                                    <div className="card" style={{width: '100%', height: 80, position: 'relative'}}>
                                        <div className="row">
                                            <button id="switch-btn"
                                                    className="btn btn-info btn-flat m-b-10 " type="button"
                                                    style={{width: 100, position: 'absolute', left: '45%'}}
                                                    onClick={swtichStatus.bind(this)}
                                            >
                                                <span id="switch-text">已停用</span>
                                                <i id="switch-icon" className="fa fa-toggle-off"/>
                                                <input type="hidden" id="switch" defaultValue="off" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="text_diff_modal" className="modal hide">
                <div className="modal-header">
                    <a>
                    </a>
                    <h3 className="subject">
                        文本比较
                        <button id="btn_submit" className="btn btn-info btn-flat m-b-10 " type="button" style={{width: 40, height: 40, position: 'absolute', left: 300}} onClick={save.bind(this, codeEditorRef)}>
                            <i className="fa fa-save">
                            </i>
                        </button>
                        <button type="button" id="modal_off" className="btn btn-danger" style={{float: 'right', position: 'relative', left: 300}} onClick={() => {$('#text_diff_modal').modal('toggle');}}>
                            关闭
                        </button>
                        <button type="button" className="btn btn-default"
                                style={{float:'right', position: 'relative', left:'75%', color: '#000'}}
                                onClick={() => {setSplitView(false)}}>
                            在一栏中比较
                        </button>
                        <button type="button" id="last" className="btn btn-default"
                                style={{float:'right', position: 'relative', left: '70%', color: '#000'}}
                                onClick={() => {setSplitView(true)}}>
                            分二栏比较
                        </button>
                    </h3>
                </div>
                <div className="modal-body">
                    <div id="diffoutput">
                        <ReactDiffViewer
                            oldValue={baseConfigValue}
                            newValue={specialConfigValue}
                            splitView={splitView}
                            leftTitle="基础配置"
                            rightTitle="特殊配置"
                        />
                    </div>
                </div>
            </div>

            <div id="text_diff_modal_group" className="modal hide">
                <div className="modal-header">
                    <a>
                    </a>
                    <h3 className="subject">
                        配置预览
                        <button type="button" className="btn btn-danger" style={{float: 'right', position: 'relative', left: 300}} onClick={() => {$('#text_diff_modal_group').modal('toggle');}}>
                            关闭
                        </button>
                        <button type="button" className="btn btn-default"
                                style={{float:'right', position: 'relative', left:'75%', color: '#000'}}
                                onClick={() => {setSplitGroupModalView(false)}}>
                            在一栏中比较
                        </button>
                        <button type="button" id="last" className="btn btn-default"
                                style={{float:'right', position: 'relative', left: '70%', color: '#000'}}
                                onClick={() => {setSplitGroupModalView(true)}}>
                            分二栏比较
                        </button>
                    </h3>
                </div>
                <div className="modal-body">
                    <div id="diffoutput_group">
                        <ReactDiffViewer
                            oldValue={baseConfigValue}
                            newValue={specialConfigValue}
                            splitView={splitGroupModalView}
                            leftTitle="base"
                            rightTitle={CurrentPlan}
                        />
                    </div>
                </div>
            </div>

            <div id="diff_history_modal" className="modal hide">
                <div className="modal-header">
                    <a>
                        修改记录
                    </a>
                    <h3 className="subject">
                        <button type="button" id="diff_modal_off" className="btn btn-danger" style={{float: 'right', position: 'relative', right: '190px'}} onClick={() => {$('#diff_history_modal').modal('toggle');}}>
                            关闭
                        </button>
                    </h3>
                </div>
                <div className="modal-body">
                    <div id="historyDiv">
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DifferentSetting;
